import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import Pagination from '../../model/pagination';
import ArtistModel from '../../model/artist.model';
import CooperationModel from '../../model/cooperation.model';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import GenericCrudService from "../genericCrud.service";

@Injectable()
export default class CooperationService extends GenericCrudService<CooperationModel> {
  public constructor(protected http: HttpClient) {
    super(http);
  }

  getApiName() {
    return 'cooperations'
  }
}
